import { createStore, applyMiddleware, compose } from 'redux';
import logger from 'redux-logger';
import { routerMiddleware } from 'react-router-redux';
import { createBrowserHistory as createHistory } from 'history';
import thunkMiddleware from 'redux-thunk';
import authFailure from 'state/middleware/authFailure';
import reducers from 'state/reducers';

const history = createHistory();
const middleware = routerMiddleware(history);
const loggerEnvironments = ['qa01', 'dev'];
const showLogger = env => loggerEnvironments.includes(env);

const middlewares = [
  thunkMiddleware.withExtraArgument({}), // TODO
  authFailure,
  middleware,
  ...(showLogger(process.env.REACT_APP_BUILD_ENV) ? [logger] : [])
];

const composeEnhancers =
  typeof window === 'object' &&
  showLogger(process.env.REACT_APP_BUILD_ENV) &&
  (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__()
    : compose;

const enhancer = composeEnhancers(applyMiddleware(...middlewares));
const store = createStore(reducers, enhancer);

export default store;
